import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import store from "./Store/store";
import { Provider } from "react-redux";
import DialogProvider from "./Components/Providers/DialogProvider";
import AppSettingsService from "./Services/AppSettingsService";
import AuthService from "./Services/AuthService";
import { primaryTheme } from "./themes";
import DrawerProvider from "./Components/Providers/DrawerProvider";
import { BrowserRouter } from "react-router-dom";

export const appSettings = new AppSettingsService();
export const authService = new AuthService(appSettings);
  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider theme={primaryTheme}>
            <DialogProvider>
              <DrawerProvider>
                <App authService={authService} />
              </DrawerProvider>
            </DialogProvider>
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
